<template>
  <div class="template chatRecord">
    <el-form :inline="true" class="div_form">
      <el-form-item :label="$t('im.common.visitorsName')">
        <el-input v-model="visitorsName" :placeholder="$t('im.common.placeholderVisitorsName')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsID')">
        <el-input v-model="visitorsID" :placeholder="$t('im.common.placeholderVisitorsID')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.chatRecord.visitorsAccount')">
        <el-input v-model="visitorsAccount" :placeholder="$t('im.chatRecord.placeholderAccount')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsType')">
        <el-select v-model="clientType" :placeholder="$t('im.chatRecord.placeholderAccount')">
          <el-option
            v-for="item in clientTypeData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.bizCodeName')">
        <el-select v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBizCodeName')">
          <el-option
            v-for="item in businessGroupData"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.startTime')">
        <el-date-picker
          v-model="startTime"
          type="datetime"
          :placeholder="$t('im.common.placeholderStartTime')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('im.common.endTime')">
        <el-date-picker
          v-model="endTime"
          type="datetime"
          :placeholder="$t('im.common.placeholderEndTime')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('im.common.chatTheme')">
        <el-select v-model="chatTheme" :placeholder="$t('im.common.placeholderChatTheme')">
          <el-option
            v-for="item in chatThemeData"
            :key="item.id"
            :label="item.dictValue"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.chatLevel')">
        <el-select v-model="chatLevel" :placeholder="$t('im.common.placeholderChatLevel')">
          <el-option
            v-for="item in chatLevelData"
            :key="item.id"
            :label="item.dictValue"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.visitorsAddress')" class="div_item">
        <el-select v-model="province" :placeholder="$t('im.common.placeholderProvince')" @change="selectProvince">
          <el-option
            v-for="item in provinceData"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
        <el-select v-model="city" :placeholder="$t('im.common.placeholderCity')">
          <el-option
            v-for="item in cityData"
            :key="item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.serviceQuality')">
        <el-select v-model="serviceQuality" :placeholder="$t('im.common.placeholderServiceQuality')">
          <el-option
            v-for="item in serviceQualityData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.serviceName')">
        <el-select v-model="chatName" :placeholder="$t('im.common.placeholderServiceName')">
          <el-option
            v-for="item in chatData"
            :key="item.userToken"
            :label="item.displayName"
            :value="item.userToken">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.chatRecordKey')">
        <el-input v-model="chatRecordKey" :placeholder="$t('im.common.placeholderChatRecordKey')"></el-input>
      </el-form-item>
      <el-form-item class="div_btn">
        <el-button type="primary" size="small" @click="searchChatRecord">{{$t('im.bt.find')}}</el-button>
        <el-button size="small" @click="resetRule">{{$t('im.bt.reset')}}</el-button>
        <el-button type="primary" size="small" @click="exportUser">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table border
              ref="checkedType"
              v-if="chatRecord"
              :data="chatRecord"
              :row-class-name="tableRowClassName"
              @select="selectRow"
              tooltip-effect="dark"
              style="width: 100%"
    >
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column :label="$t('im.common.detail')" width="55">
        <template slot-scope="scope">
          <el-button :class="scope.row.viewTag==1?'detail hasRead':'detail'" type="text" @click="goChatDetailPop(scope.row,scope.$index)">{{$t('im.common.detail')}}</el-button>
        </template>
      </el-table-column>
      <el-table-column :prop="item.id" :label="item.name" v-for="item in chatRecordNav" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <div class="block flexEnd" v-if="totalNum>0">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[8,16, 24, 32, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </div>
    <el-dialog :title="$t('im.commonChat.chatInfo')" :visible.sync="isToChatDetailPop" width="70%" :before-close="cancelUserAccess">
      <div class="padding scrollY" :style="{'max-height':util.accSub((util.accDiv(height,1.3)),190)+'px'}">
        <div class="padding">
          <div class="title_tc"><span>{{$t('im.commonChat.customerInfo')}}</span></div>
          <div class="assessInfo">
            <ul>
              <li><span>{{$t('im.common.userID')}}：</span><p>{{customerInfo.customerId}}</p></li>
              <li><span>{{$t('im.common.tradePlatform')}}：</span><p>{{customerInfo.tradePlatform}}</p></li>
              <li><span>{{$t('im.common.userTypeName')}}：</span><p>{{customerInfo.userTypeName}}</p></li>
              <li><span>{{$t('im.common.name')}}：</span><p>{{customerInfo.name}}</p></li>
              <li><span>{{$t('im.common.accountNum')}}：</span><p>{{customerInfo.account}}</p></li>
              <li><span>{{$t('im.common.sex')}}：</span><p>{{util.isEmpty(customerInfo.sex)?"":customerInfo.sex==0?$t('im.common.boy'):$t('im.common.girl')}}</p></li>
              <li><span>{{$t('im.common.accountStatus')}}：</span><p>{{util.isEmpty(customerInfo.activeStatus)?"":customerInfo.activeStatus==0?$t('im.common.inactivated'):$t('im.common.activated')}}</p></li>
              <li><span>{{$t('im.common.visitorsAddress')}}：</span><p>{{customerInfo.userAddress}}</p></li>
              <li><span>{{$t('im.common.telephone')}}：</span><p>{{customerInfo.phone}}</p></li>
              <li><span>{{$t('im.common.activeTime')}}：</span><p>{{customerInfo.activeTime}}</p></li>
              <li><span>{{$t('im.common.userSource')}}：</span><p>{{customerInfo.userSource}}</p></li>
              <li><span>{{$t('im.common.qq')}}：</span><p>{{customerInfo.qq}}</p></li>
              <li><span>{{$t('im.common.lastTradeTime')}}：</span><p>{{customerInfo.lastTradeTime}}</p></li>
              <li><span>{{$t('im.common.locale')}}：</span><p>{{customerInfo.localeName}}</p></li>
              <li><span>{{$t('im.common.weChat')}}：</span><p>{{customerInfo.wechat}}</p></li>
              <li><span>{{$t('im.common.tradeHandNum')}}：</span><p>{{customerInfo.tradeHandNum}}</p></li>
              <li><span>{{$t('im.common.lastMoneyTime')}}：</span><p>{{customerInfo.lastMoneyTime}}</p></li>
              <li><span>{{$t('im.common.email')}}：</span><p>{{customerInfo.email}}</p></li>
              <li><span>{{$t('im.common.activityNum')}}：</span><p>{{customerInfo.activityNum}}</p></li>
              <li><span>{{$t('im.common.ccFollow')}}：</span><p>{{customerInfo.ccFollow}}</p></li>
              <li><span>{{$t('im.common.csFollow')}}：</span><p>{{customerInfo.csFollow}}</p></li>
              <li><span>{{$t('im.common.rmFollow')}}：</span><p>{{customerInfo.rmFollow}}</p></li>
              <li><span>{{$t('im.common.bizCodeName')}}：</span><p>{{customerInfo.bizCodeName}}</p></li>
            </ul>
          </div>
        </div>
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="title_tc"><span>{{$t('im.commonChat.chatRecord1')}}{{evaluatedInfo.customerId}}{{$t('im.commonChat.chatRecord2')}}</span></div>
            <div class="singleRecord boxShadow">
              <span>{{$t('im.commonChat.chatStart')}}：{{evaluatedInfo.startTime}}</span>
              <ul>
                <li v-for="item in singleChatRecord" :class="util.isNotEmpty(item.fromCustomerId)?'chat':'client'">
                  <p>{{item.fromName}}<em>({{item.createDate}})</em></p>
                  <span v-html="item.message"></span>
                  <span v-if="item.messageType==2&&util.isNotEmpty(item.previousQuestion)"><em>{{item.previousQuestion}}</em></span>
                  <span v-if="item.messageType==7">
                    {{item.locale=='zh_CN'?'对不起，'+item.fromName+'还不会这个问题，是否转人工服务？点这里转人工客服':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' do you want to switch to Staff Service? Click here to switch':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách có muốn chuyển sang nhân viên CSKH không? Nhấn vào đây để chuyển':''}}
                  </span>
                  <span v-if="item.messageType==8">
                    {{item.locale=='zh_CN'?'对不起，这个问题难倒'+item.fromName+'了，是否给我们留言？点这里留言':item.locale=='en_US'?'Sorry，this question is difficult for '+item.fromName+' would you please leave us a messenger? Click here to leave':item.locale=='vi_VN'?'Xin lỗi，vấn đề này '+item.fromName+' không trả lời được, quý khách xin để lại lời dặn cho chúng tôi? >Nhấn vào Đây để viết lời dặn':''}}
                  </span>
                  <span v-if="(item.messageType==1||item.messageType==9)&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"您是否需要以下帮助？点击标题查看。":item.locale=='en_US'?"You may need those information? Please click the title to view details.":item.locale=='vi_VN'?"Chào bạn, bạn có cần những giúp đỡ bên dưới? Nhấn vào tiêu đề để tìm hiểu chi tiết.":""}}
                  </span>
                  <span v-if="item.messageType==2&&item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    {{item.locale=='zh_CN'?"相关问题：":item.locale=='en_US'?"Related Questions:":item.locale=='vi_VN'?"Vấn đề liên quan:":""}}
                  </span>
                  <ul v-if="item.conKnowledgeVos&&item.conKnowledgeVos.length>0">
                    <li v-for="(intelligent,index) in item.conKnowledgeVos">
                      <span>{{index+1}}. {{intelligent.title}}</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <span>{{$t('im.commonChat.chatEnds')}}：{{evaluatedInfo.endTime}}</span>
              <span>{{evaluatedInfo.endReason==0?$t('im.commonChat.customerOff'):$t('im.commonChat.chatClose')}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="title_tc"><span>{{$t('im.commonChat.evaluatedInfo')}}</span></div>
            <div class="dv_list boxShadow">
              <ul>
                <li><span>{{$t('im.common.startTime')}}：</span><p>{{evaluatedInfo.startTime}}</p></li>
                <li><span>{{$t('im.common.endTime')}}：</span><p>{{evaluatedInfo.endTime}}</p></li>
                <li><span>{{$t('im.common.sessionTime')}}：</span><p>{{evaluatedInfo.sessionTime}}</p></li>
                <li><span>{{$t('im.common.visitorsID')}}：</span><p>{{evaluatedInfo.customerId}}</p></li>
                <li><span>{{$t('im.common.serviceName')}}：</span><p>{{evaluatedInfo.serviceName}}</p></li>
                <li><span>{{$t('im.common.visitorsIp')}}：</span><p>{{evaluatedInfo.userIp}}</p></li>
                <li><span>{{$t('im.common.visitorsAddress')}}：</span><p>{{evaluatedInfo.userAddress}}</p></li>
                <li><span>{{$t('im.common.visitorsWay')}}：</span><p>{{evaluatedInfo.clientName}}</p></li>
                <li>
                  <span>{{$t('im.common.chatTheme')}}：</span>
                  <el-select v-model="chatThemeTc" :placeholder="$t('im.common.placeholderChatTheme')">
                    <el-option
                      v-for="item in chatThemeData"
                      :key="item.id"
                      :label="item.dictValue"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <li>
                  <span>{{$t('im.common.chatLevel')}}：</span>
                  <el-select v-model="chatLevelTc" :placeholder="$t('im.common.placeholderChatLevel')">
                    <el-option
                      v-for="item in chatLevelData"
                      :key="item.id"
                      :label="item.dictValue"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <li>
                  <span>{{$t('im.common.remark')}}</span>
                  <el-input type="textarea" :rows="4" :placeholder="$t('im.common.placeholderRemark')" maxlength="100" show-word-limit v-model="evaluatedReason"></el-input>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="flexCenter">
        <el-button type="primary" size="small" @click="saveUserAccess">{{$t('im.bt.saveAndNext')}}</el-button>
        <el-button size="small" @click="nextAssessmentStatus">{{$t('im.bt.noAndNext')}}</el-button>
        <el-button size="small" @click="cancelUserAccess">{{$t('im.bt.cancel')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import URL from "@/api/im/url";

  require('@/styles/IM/template.css')
  import Util from '@/utils/IM/tradeDataUtil'
  import apiChatSystem from '@/api/im/chatSystem'
  import apiDeployManagement from '@/api/im/deployManagement'
  import { localRead } from '@/utils/tools'
  import { TextToCode } from 'element-china-area-data'
  import imStore from '@/store/modules/im'
  import download from '@/utils/download'
  export default {
    name: 'commonRecord',
    props: ['recordType'],
    computed:{
      checkedDatas:{
        get(){
          return this.$store.state.im.checkedData
        }
      }
    },
    data() {
      return {
        util: Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),
        visitorsName: '',//访客名称
        visitorsID: '',//访客ID
        visitorsAccount: '',//访客账号
        clientTypeData: [
          { name: window.$t('im.common.mobile'), id: 0 },
          { name: window.$t('im.common.pc'), id: 1 },
          { name: window.$t('im.common.app'), id: 2 }
        ],//访客方式
        clientType: '',
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: '',  //业务编码Code
        bizCodes: [],//业务编码Code组
        startTime: '',//开始时间
        endTime: '',//结束时间
        chatThemeData: [],//对话主题
        chatTheme: '',
        chatThemeTc: '',
        chatLevelData: [],//对话级别
        chatLevel: '',
        chatLevelTc: '',
        serviceQualityData: [
          { name: window.$t('im.chatRecord.serviceQuality0'), id: 0 },
          { name: window.$t('im.chatRecord.serviceQuality1'), id: 1 },
          { name: window.$t('im.chatRecord.serviceQuality2'), id: 2 },
          { name: window.$t('im.chatRecord.serviceQuality3'), id: 3 },
          { name: window.$t('im.chatRecord.serviceQuality4'), id: 4 },
          { name: window.$t('im.chatRecord.serviceQuality5'), id: 5 }
        ],//服务质量
        serviceQuality: '',
        chatData: [],//客服列表
        chatName: '',
        provinceData: [],//省份数据
        province: '',
        cityData: [],//城市数据
        city: '',
        currentPage: 1,  //当前页数
        pageSize: 8, //当前页条数数
        totalNum: 0,  //当前资源条数
        chatRecord: '',//会话记录列表
        chatRecordNav: [
          { name: window.$t('im.common.bizCodeName'), id: 'bizCodeName' },
          { name: window.$t('im.common.visitorsID'), id: 'customerId' },
          { name: window.$t('im.commonChat.chatID'), id: 'sessionId' },
          { name: window.$t('im.common.visitorsName'), id: 'name' },
          { name: window.$t('im.common.accountNum'), id: 'account' },
          { name: window.$t('im.common.visitorsWay'), id: 'clientName' },
          { name: window.$t('im.common.visitorsSource'), id: 'userSource' },
          { name: window.$t('im.common.startTime'), id: 'startTime' },
          { name: window.$t('im.common.endTime'), id: 'endTime' },
          { name: window.$t('im.common.sessionTime'), id: 'sessionTime' },
          { name: window.$t('im.common.visitorsIp'), id: 'userIp' },
          { name: window.$t('im.common.visitorsAddress'), id: 'userAddress' },
          { name: window.$t('im.common.serviceName'), id: 'serviceName' },
          { name: window.$t('im.common.serviceQuality'), id: 'serviceQualityName' },
          { name: window.$t('im.common.lastAccessAddress'), id: 'lastAccessAddress' },
          { name: window.$t('im.common.chatTheme'), id: 'sessionTopicName' },
          { name: window.$t('im.common.chatLevel'), id: 'sessionLevelName' }
        ],//会话记录标题
        isToChatDetailPop: false,//是否展示客户详细信息弹窗
        customerInfo: [],//客户信息
        evaluatedIndex:"",//评估信息的索引
        evaluatedInfo: '',//评估个人信息
        evaluatedReason: '',//客户进行评估的备注
        singleChatRecord: [],//聊天记录
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        userTypeData: [
          { name: window.$t('im.common.traveler'), id: 0 },
          { name: window.$t('im.common.demo'), id: 1 },
          { name: window.$t('im.common.inactivated'), id: 2 },
          { name: window.$t('im.common.activated'), id: 3 }
        ],//用户类型
        sexData: [
          { name: window.$t('im.common.boy'), id: 0 },
          { name: window.$t('im.common.girl'), id: 1 }
        ],//性别
        chatRecordKey:""//聊天记录关键字
      }
    },
    methods: {
      docHeight() {
        this.height = window.innerHeight || document.documentElement.clientHeight
      },
      /*初始化业务组*/
      initBusinessGroup() {
        let data = []
        if (this.businessGroupData.length > 0) {
          for (const i in this.businessGroupData) {
            data.push(this.businessGroupData[i].code)
          }
          this.bizCodes = data
        }
      },
      /*刷选业务列表*/
      brushBusinessGroup(obj) {
        for (const j in this.businessGroupData) {
          if (this.businessGroupData[j].code == obj.bizCode) {
            obj.bizCodeName = this.businessGroupData[j].name
          }
        }
        return obj
      },
      /*刷选访客方式*/
      brushClientType(obj) {
        for (const j in this.clientTypeData) {
          if (this.clientTypeData[j].id == obj.clientType) {
            obj.clientName = this.clientTypeData[j].name
          }
        }
        return obj
      },
      /*刷选服务质量*/
      brushServiceQuality(obj) {
        for (const j in this.serviceQualityData) {
          if (this.serviceQualityData[j].id == obj.serviceQuality) {
            obj.serviceQualityName = this.serviceQualityData[j].name
          }
        }
        return obj
      },
      /*刷选用户类型*/
      brushUserType(obj) {
        for (const j in this.userTypeData) {
          if (this.userTypeData[j].id == obj.userType) {
            obj.userTypeName = this.userTypeData[j].name
          }
        }
        return obj
      },
      /*刷选语言*/
      brushLocale(obj) {
        for (const j in this.langList) {
          if (this.langList[j].id == obj.locale) {
            obj.localeName = this.langList[j].name
          }
        }
        return obj
      },
      /*刷选性别*/
      brushSex(obj) {
        for (const j in this.sexData) {
          if (this.sexData[j].id == obj.sex) {
            obj.sexName = this.sexData[j].name
          }
        }
        return obj
      },
      /*获取数据*/
      getChatRecord(data) {
        let param = {
          account: this.visitorsAccount,
          name:this.visitorsName,
          customerId: this.visitorsID,
          clientType: this.clientType,
          bizCode: this.businessGroupCode,
          queryStartTime: Util.isNotEmpty(this.startTime) ? new Date(this.startTime).format('Y-MM-dd hh:mm:ss') : '',
          queryEndTime: Util.isNotEmpty(this.endTime) ? new Date(this.endTime).format('Y-MM-dd hh:mm:ss') : '',
          sessionLevel: this.chatLevel,
          sessionTopic: this.chatTheme,
          serviceQuality: this.serviceQuality,
          serviceToken: this.chatName,
          province: this.province,
          city: this.city,
          // assessmentStatus: this.recordType == 0 ? '' : 1,
          companyId: this.userInfo.companyId,
          bizCodes: this.bizCodes,
          sessionType: this.recordType,
          viewName: this.userInfo.userName,
          chatMessageKey:this.chatRecordKey
        }
        param = { ...param, ...data }
        apiChatSystem.querySessionListPage(param).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                if (newData[i].userType == 0 || Util.isEmpty(newData[i].userType)) newData[i].account = ''
                this.brushBusinessGroup(newData[i])
                this.brushClientType(newData[i])
                this.brushServiceQuality(newData[i])
                this.$nextTick(() => {
                  setTimeout(() => {
                    if (Util.isNotEmpty(this.$refs.checkedType)) {
                      if (this.checkedDatas && this.checkedDatas.length > 0) {
                        this.checkedDatas.forEach(row => {
                          if (row.id == newData[i].id) {
                            this.$refs.checkedType.toggleRowSelection(newData[i], true)
                          }
                        })
                      }
                    }
                  }, 10)
                })
              }
              this.chatRecord = newData
            } else {
              this.chatRecord = []
            }
            this.totalNum = res.result.total
          }
        })
      },
      exportUser() {
        let param = {
          account: this.visitorsAccount,
          name:this.visitorsName,
          customerId: this.visitorsID,
          clientType: this.clientType,
          bizCode: this.businessGroupCode,
          queryStartTime: Util.isNotEmpty(this.startTime) ? new Date(this.startTime).format('Y-MM-dd hh:mm:ss') : '',
          queryEndTime: Util.isNotEmpty(this.endTime) ? new Date(this.endTime).format('Y-MM-dd hh:mm:ss') : '',
          sessionLevel: this.chatLevel,
          sessionTopic: this.chatTheme,
          serviceQuality: this.serviceQuality,
          serviceToken: this.chatName,
          province: this.province,
          city: this.city,
          // assessmentStatus: this.recordType == 0 ? '' : 1,
          companyId: this.userInfo.companyId,
          bizCodes: this.bizCodes,
          sessionType: this.recordType,
          viewName: this.userInfo.userName,
          chatMessageKey:this.chatRecordKey
        }
        const data = Object.assign(JSON.parse(JSON.stringify(param)), {});
        download.exportExcel(URL.record.export,data,"用户会话数据");
      },
      /*初始化对话记录*/
      initChatRecord() {
        let data = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
        this.getChatRecord(data)
      },
      /*切换对话记录分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          pageNum: this.currentPage,
          pageSize: val,
        }
        this.getChatRecord(data)
      },
      /*切换对话记录当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          pageNum: val,
          pageSize: this.pageSize,
        }
        this.getChatRecord(data)
      },
      /*刷选对话记录*/
      searchChatRecord() {
        let data = {
          pageNum: 1,
          pageSize: this.pageSize,
        }
        this.getChatRecord(data)
      },
      /*重置*/
      resetRule() {
        this.visitorsAccount = ''
        this.visitorsName=''
        this.visitorsID = ''
        this.clientType = ''
        this.businessGroupCode = ''
        this.startTime = ''
        this.endTime = ''
        this.chatLevel = ''
        this.chatTheme = ''
        this.serviceQuality = ''
        this.chatName = ''
        this.province = ''
        this.city = ''
        this.cityData = []
        this.currentPage = 0
        this.initChatRecord()
      },
      /*初始化主题、级别*/
      initChatList(type) {
        let data = {
          companyId: this.userInfo.companyId,
          dictType: type,
          pageNum: this.currentPage
        }
        apiDeployManagement.queryConAccessDictList(data).then(res => {
          if (res.code == 0) {
            if (type == 0) {
              if (res.result) {
                this.chatThemeData = res.result
              } else {
                this.chatThemeData = []
              }
            } else if (type == 1) {
              if (res.result) {
                this.chatLevelData = res.result
              } else {
                this.chatLevelData = []
              }
            }
          }
        })
      },
      /*初始化客服列表*/
      initThisList() {
        let data = { companyId: this.userInfo.companyId }
        apiChatSystem.getThisList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              this.chatData = res.result
            }
          }
        })
      },
      /*初始化地区*/
      initArea() {
        for (const i in TextToCode) {
          this.provinceData.push({ name: i, code: TextToCode[i].code })
        }
      },
      /*选择省份*/
      selectProvince(val) {
        this.city = ''
        let data = JSON.parse(JSON.stringify(TextToCode[val]))
        let newData = [], name = ''
        delete data['全部']
        delete data.code
        for (const i in data) {
          if (i == '市辖区') {
            name = val
          } else {
            name = i
          }
          newData.push({ name: name, code: data[i].code })
        }
        this.cityData = newData
      },
      tableRowClassName(data) {
        if (data.row.viewTag == 1) {
          return 'hasRead'
        }
        return '';
      },
      selectRow(data){
        imStore.dispatch('setCheckedData', data)
      },
      /*对话详情*/
      goChatDetailPop(obj, index) {
        this.isToChatDetailPop = true
        this.evaluatedIndex = index
        this.evaluatedInfo = obj
        this.chatLevelTc = obj.sessionLevel
        this.chatThemeTc = obj.sessionTopic
        this.evaluatedReason = obj.assessmentContent
        this.getViewTag(obj.id)
        this.initUserInfo(obj.userToken)
        this.getChatMessageList(obj.sessionId)
      },
      /*获取是否阅读标记*/
      getViewTag(id){
        let data = {
          username: this.userInfo.userName,
          accessId: id
        }
        apiChatSystem.addAccessViewTag(data).then(res => {
          if (res.code != 0 || res.result != true) {
            this.$message.error(res.message)
          }
        })
      },
      /*用户信息*/
      initUserInfo(userToken) {
        let data = {
          userToken: userToken
        }
        apiChatSystem.queryBizUserVo(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let newData = JSON.parse(JSON.stringify(res.result))
              this.brushUserType(newData)
              this.brushClientType(newData)
              this.brushBusinessGroup(newData)
              this.brushLocale(newData)
              this.brushSex(newData)
              if (newData.userType == 0) newData.account = ''
              this.customerInfo = newData
            } else {
              this.customerInfo = []
            }
          }
        })
      },
      /*客服与某位用户的聊天记录*/
      getChatMessageList(sessionId) {
        if (Util.isNotEmpty(sessionId)) {
          let data = {
            sessionId: sessionId
          }
          apiChatSystem.queryUserChatMessageList(data).then(res => {
            if (res.code == 0) {
              if (res.result.length > 0) {
                this.singleChatRecord = res.result
              } else {
                this.singleChatRecord = []
              }
            }
          })
        } else {
          this.singleChatRecord = []
        }
      },
      /*保存评估信息*/
      saveUserAccess() {
        if (Util.isNotEmpty(this.chatLevelTc) && Util.isNotEmpty(this.chatThemeTc)) {
          let data = {
            serviceToken: this.evaluatedInfo.serviceToken,
            id: this.evaluatedInfo.id,
            sessionLevel: this.chatLevelTc,
            sessionTopic: this.chatThemeTc,
            assessmentContent: this.evaluatedReason,
            assessmentStatus: 1
          }
          apiChatSystem.updateListAssessmentStatus(data).then(res => {
            if (res.code == 0 && res.result == true) {
              for (const i in this.chatRecord) {
                if (i == this.evaluatedIndex) {
                  let data = {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                  }
                  this.getChatRecord(data)
                  if ((Number(i) + 1) < this.chatRecord.length) {
                    this.$message.success(window.$t('im.commonChat.evaluatedSuc'))
                    this.evaluatedInfo = this.chatRecord[Number(i) + 1]
                    this.chatLevelTc = this.chatRecord[Number(i) + 1].sessionLevel
                    this.chatThemeTc = this.chatRecord[Number(i) + 1].sessionTopic
                    this.evaluatedReason = this.chatRecord[Number(i) + 1].assessmentContent
                    this.initUserInfo(this.chatRecord[Number(i) + 1].userToken)
                    this.getChatMessageList(this.chatRecord[Number(i) + 1].sessionId)
                  }
                }
              }
              this.evaluatedIndex++
              if (this.evaluatedIndex >= this.chatRecord.length) {
                this.$message.success(window.$t('im.chatRecord.saveSuc'))
              }
            }
          })
        } else {
          this.$message.error(window.$t('im.commonChat.isNotNull'))
        }
      },
      nextAssessmentStatus(){
        for (const i in this.chatRecord) {
          if (i == this.evaluatedIndex) {
            this.getViewTag(this.chatRecord[Number(i) + 1].id)
            if ((Number(i) + 1) < this.chatRecord.length) {
              this.evaluatedInfo = this.chatRecord[Number(i) + 1]
              this.chatLevelTc = this.chatRecord[Number(i) + 1].sessionLevel
              this.chatThemeTc = this.chatRecord[Number(i) + 1].sessionTopic
              this.evaluatedReason = this.chatRecord[Number(i) + 1].assessmentContent
              this.initUserInfo(this.chatRecord[Number(i) + 1].userToken)
              this.getChatMessageList(this.chatRecord[Number(i) + 1].sessionId)
            }
          }
        }
        this.evaluatedIndex++
        if (this.evaluatedIndex >= this.chatRecord.length) {
          this.$message.info(window.$t('im.chatRecord.noNext'))
        }
      },
      cancelUserAccess(){
        this.isToChatDetailPop = false
        let data = {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        }
        this.getChatRecord(data)
      }
    },
    mounted() {
      this.docHeight()
      this.initBusinessGroup()
      this.initChatRecord()
      this.initChatList(0)
      this.initChatList(1)
      this.initThisList()
      this.initArea()
    }
  }
</script>
<style>
  .chatRecord .div_form .el-form-item{width: 23%}
  .chatRecord .div_form .el-form-item__content{width: 69%}
  .chatRecord .div_form .el-date-editor,
  .chatRecord .div_form .el-select{width: 100%}
  .chatRecord .div_form .div_item .el-form-item__content .el-select{width: 47.5%;float: left;margin-right: 2.5%}
  .chatRecord .div_form .div_item .el-form-item__content .el-select:last-child{margin-left: 2.5%;margin-right:0}
  .chatRecord .div_form .div_btn .el-form-item__content{width: 100%}
  .chatRecord .padding{padding: 0 0 20px}
  .chatRecord .dv_list li{margin: 11.2px 0}
  .chatRecord .el-textarea .el-input__count{width: auto!important;height: auto}
  .chatRecord .detail.hasRead.el-button--text,
  .chatRecord .el-table .hasRead .cell.el-tooltip{color: #999}
  .chatRecord .el-table .hasRead {
    background: #fafafa;
  }
</style>
